import _ from 'lodash'
import { FormGroup, Radio, RadioItem } from '@agro-club/agroclub-shared'
import { useAFormHandler } from 'analytics/hooks'
import { FormikProps, useFormik } from 'formik'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { SharedModalContent, SharedModalInputs } from 'views/components/SharedModal'
import { FormItemWrapper } from 'views/styled/common'
import { Address, BuyerWarehouseDTO, WarehouseDTO } from 'modules/domain/types'
import { HrWithHeader } from '../Hr/Hr'
import { SharedModalSecondContent } from '../SharedModal/styled'
import { BuyerWarehouseFields } from '../WarehouseModal/BuyerWarehouseFields'

type Props = {
  onClose: () => void
  changeDealStatusHandler: () => Promise<unknown> | void
  customerAddress: Address
  customerCompanyId: number
  dealId: number
  has_filled_unload_address_params: boolean
}

type Fields = BuyerWarehouseDTO & { customer_overload: boolean }

export const ToNewModal: FC<Props> = ({
  onClose,
  changeDealStatusHandler,
  customerAddress,
  customerCompanyId,
  dealId,
  has_filled_unload_address_params,
}) => {
  const { t } = useTranslation(['deal', 'common', 'address'])
  const { formProgress, formHandler } = useAFormHandler()

  const handleChangeDealStatus = async () => {
    await changeDealStatusHandler()
    onClose()
  }

  const formik = useFormik<Fields>({
    initialValues: {
      customer_overload: false,

      is_dump_truck: customerAddress.is_dump_truck,
      schedule_from: customerAddress.schedule_from,
      schedule_to: customerAddress.schedule_to,
      unloading_type: customerAddress.unloading_type,
      vehicle_type: customerAddress.vehicle_type,
      overload: customerAddress.overload,
      volume_per_day: customerAddress.volume_per_day,
      works_on_weekend: customerAddress.works_on_weekend,
      car_delivery: customerAddress.car_delivery,
      railway_delivery: customerAddress.railway_delivery,
      weather_conditions: customerAddress.weather_conditions,
      timeslot_required: customerAddress.timeslot_required,
    },

    onSubmit: formHandler(
      async () => {
        await apiClient.patch(endpoints.setOverload(dealId), {
          customer_overload: formik.values.customer_overload,
        })
        if (has_filled_unload_address_params) {
          const addressDTO = _.omit(formik.values, 'customer_overload')
          await apiClient.put<WarehouseDTO>(
            endpoints.companyAddressDetails(customerCompanyId.toString(), customerAddress.id),
            addressDTO,
          )
        }
      },
      {
        onSuccess: async () => {
          await handleChangeDealStatus()
          onClose()
        },
        onError: (error) => {
          const { errors } = error
          formik.setErrors(errors)
        },
      },
    ),
  })
  return (
    <ResponsiveModal
      id="moveDealToNew"
      title={t('ToNew')}
      progress={formProgress}
      onConfirm={formik.submitForm}
      onClose={onClose}
      size="large"
    >
      <SharedModalContent>
        <HrWithHeader text={t('TraderOverloadTitle')} />
        <SharedModalSecondContent>
          <SharedModalInputs>
            <FormGroup label={t('address:fields.overload')} error={formik.errors.customer_overload}>
              <FormItemWrapper>
                <Radio
                  value={formik.values.customer_overload}
                  onChange={(customer_overload) => formik.setFieldValue('customer_overload', customer_overload)}
                >
                  <RadioItem value={false} label={t('address:overLoadTypes.normal')} />
                  <RadioItem value={true} label={t('address:overLoadTypes.full')} />
                </Radio>
              </FormItemWrapper>
            </FormGroup>
          </SharedModalInputs>
        </SharedModalSecondContent>
        {has_filled_unload_address_params && (
          <>
            <SharedModalSecondContent>
              <HrWithHeader text={t('unloadingAddressParams')} />
            </SharedModalSecondContent>
            <SharedModalSecondContent>
              <SharedModalInputs>
                <BuyerWarehouseFields formik={formik as unknown as FormikProps<BuyerWarehouseDTO>} />{' '}
                {/* failed to make formik work with wildcard fields */}
              </SharedModalInputs>
            </SharedModalSecondContent>
          </>
        )}
      </SharedModalContent>
    </ResponsiveModal>
  )
}
